import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useApi } from './client.js';

// Per-org visit-arrived auto check-in policy. `{ enabled }` only; mirrors the
// escalation-settings hook. Default off — rolled out tenant-by-tenant.
export interface VisitAutoCheckinSettings {
  enabled: boolean;
}

export function useVisitAutoCheckinSettings() {
  const api = useApi();
  return useQuery({
    queryKey: ['organisation', 'visit-auto-checkin-settings'],
    queryFn: () => api<VisitAutoCheckinSettings>('/organisations/visit-auto-checkin-settings'),
    staleTime: 60_000,
  });
}

export function useUpdateVisitAutoCheckinSettings() {
  const api = useApi();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: Partial<VisitAutoCheckinSettings>) =>
      api<VisitAutoCheckinSettings>('/organisations/visit-auto-checkin-settings', {
        method: 'PATCH',
        body: JSON.stringify(input),
      }),
    onSuccess: (next) => {
      qc.setQueryData(['organisation', 'visit-auto-checkin-settings'], next);
    },
  });
}
